import React from 'react'
import history from 'browserHistory'
import RoutesHelper from 'helpers/RoutesHelper'

import { ThinChevronIcon } from 'components/Utils/Icons'

class BackToIntegrations extends React.PureComponent {
  handleBackToIntegrations = event => {
    event.preventDefault()
    history.push(RoutesHelper.settingsIntegrations())
  }

  render() {
    return (
      <div
        className="flexbox flexbox-align-center shade-20 margin-bottom-largest pointer"
        onClick={this.handleBackToIntegrations}
      >
        <ThinChevronIcon
          className="margin-right-small"
          size={12}
          style={{ transform: 'rotate(180deg)' }}
        />
        <div>Back to your integrations</div>
      </div>
    )
  }
}

export default BackToIntegrations
